import { Physics, Debug } from "@react-three/cannon";
import { Canvas } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import { useEffect, useState } from "react";

import InfoButton from "../components/InfoButton";

import Cursor from "./objects/Cursor";
import Plane from "./objects/Plane";
import Door from "./objects/Door";
import ClosetPipe from "./objects/ClosetPipe";
import ShoeBox from "./objects/ShoeBox";
import Lightning from "./objects/Lightning";
import Bed from "./objects/Bed";
import Pillow from "./objects/Pillow";
import PillowTwitter from "./objects/PillowTwitter";
import PillowGithub from "./objects/PillowGithub";
import PillowMail from "./objects/PillowMail";
import Ball from "./objects/Ball";
import Desk from "./objects/Desk";
import Computer from "./objects/Computer";
import ComputerKeyboard from "./objects/ComputerKeyboard";
import ComputerKeyboardPad from "./objects/ComputerKeyboardPad";
import ComputerMouse from "./objects/ComputerMouse";
import ComputerMousePad from "./objects/ComputerMousePad";
import MonitorC from "./objects/MonitorC";
import MonitorStand from "./objects/MonitorStand";
import Trash from "./objects/Trash";
import WeightScale from "./objects/WeightScale";
import Dumbbell from "./objects/Dumbbell";
import PushUpBar from "./objects/PushUpBar";
import StandingMirror from "./objects/StandingMirror";
import ClosetHanger from "./objects/ClosetHanger";
import GuitarStand from "./objects/GuitarStand";
import Guitar from "./objects/Guitar";
import CardCase from "./objects/CardCase";
import Wallet from "./objects/Wallet";

import Ragdoll from "./objects/Ragdoll";

export default () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
      const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
      setIsMobile(mobileRegex.test(userAgent.toLowerCase()) || window.innerWidth <= 768);
      // setIsMobile(true); // todo:削除
    };

    const handleResize = () => { checkMobile(); };
    checkMobile();

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isMobile]);

  return (
    <>
      <Canvas
        camera={{ far: 100, near: 1, position: [-25, 20, 25], zoom: isMobile ? 20 : 25 }}
        orthographic
        shadows
        style={{ height: '100vh', width: '100vw' }}
      >
        <color attach="background" args={['#1a1a1a']} />
        <fog attach="fog" args={['#1a1a1a', 20, 80]} />
        <ambientLight intensity={0.2 * Math.PI} />
        <pointLight decay={0} position={[-10, -10, -10]} color="orange" intensity={0.1 * Math.PI} />

        <OrbitControls 
          enablePan={isMobile} 
          enableZoom={isMobile} 
          enableRotate={isMobile} 
          minDistance={isMobile ? 10 : 25} 
          maxDistance={25} 
          target={[0, 0, 0]} 
        />

        <Physics 
          iterations={30}
          gravity={[0, -200, 0]}
          allowSleep={true}
        >
          {/* <Debug color="red" scale={1} > */}
            {!isMobile && <Cursor />}
            <Plane                 position={[     0,   -8,     0]} rotation={[-Math.PI / 2,               0,           0]} />
            <Door                  position={[  20.5, 1.25, 12.50]} rotation={[           0,               0,           0]} />
            <ShoeBox               position={[    16, -3.5,     7]} rotation={[           0,               0,           0]} />
            <ClosetPipe            position={[  16.5,    9,    -6]} rotation={[           0,     Math.PI / 2,           0]} />
            <Lightning             position={[     0,   16,     0]} rotation={[           0,               0,           0]} />

            <Bed                   position={[   -13,   -7,     8]} rotation={[           0,     Math.PI / 2,           0]} />
            <Pillow                position={[   -13,   -5,     1]} rotation={[           0,               0,           0]} />
            <PillowTwitter         position={[   -16,   -5,     9]} rotation={[           0,               0,           0]} />
            <PillowGithub          position={[   -16,   -5,     6]} rotation={[           0,               0,           0]} />
            <PillowMail            position={[   -16,   -5,    12]} rotation={[           0,               0,           0]} />

            <Ball                  position={[   -13,   -5,    -6]} rotation={[           0,               0,           0]} />
            <Desk                  position={[   -12, -4.5,   -13]} rotation={[           0,               0,           0]} />
            <Computer              position={[-16.75, -4.8,   -13]} rotation={[           0,               0,           0]} />
            <ComputerKeyboard      position={[ -11.5, -0.75,  -13]} rotation={[           0,               0,           0]} />
            <ComputerKeyboardPad   position={[ -11.5, -0.75,  -11]} rotation={[           0,               0,           0]} />
            <ComputerMousePad      position={[ -7.25, -0.5, -11.5]} rotation={[           0,               0,           0]} />
            <ComputerMouse         position={[  -7.5, -0.5, -11.5]} rotation={[           0,               0,           0]} />
            <MonitorC              position={[ -7.25,  0.1,-14.25]} rotation={[-Math.PI / 4,               0,           0]} />
            <MonitorStand          position={[ -7.25,    0, -14.5]} rotation={[           0,               0,           0]} />

            <Trash                 position={[  -3.5,   -7,   -14]} rotation={[           0,               0,           0]} />
            <WeightScale           position={[     9, -7.9,     3]} rotation={[           0,     Math.PI / 2,           0]} />
            <Dumbbell              position={[     3,   -7,     0]} rotation={[           0,               0,           0]} />
            <PushUpBar             position={[     5, -7.5,     2]} rotation={[           0,               0,           0]} />
            <PushUpBar             position={[   4.5, -7.5,   2.5]} rotation={[           0,               0,           0]} />
            <StandingMirror        position={[    10, -1.3,   -13]} rotation={[-Math.PI / 24,  Math.PI / 1.2,Math.PI / 48]} />

            <ClosetHanger          position={[  16.5,    7,  -9.8]} rotation={[           0,               0,           0]} />
            <ClosetHanger          position={[  16.5,    7,  -9.6]} rotation={[           0,               0,           0]} />
            <ClosetHanger          position={[  16.5,    7,  -9.4]} rotation={[           0,               0,           0]} />
            <ClosetHanger          position={[  16.5,    7,  -9.2]} rotation={[           0,               0,           0]} />
            <ClosetHanger          position={[  16.5,    7,  -5.5]} rotation={[           0,               0,           0]} />
            <ClosetHanger          position={[  16.5,    7,  -5.1]} rotation={[           0,               0,           0]} />
            <ClosetHanger          position={[  16.5,    7,  -4.9]} rotation={[           0,               0,           0]} />
            <ClosetHanger          position={[  16.5,    7,  -4.7]} rotation={[           0,               0,           0]} />
            <ClosetHanger          position={[  16.5,    7,  -1.4]} rotation={[           0,               0,           0]} />
            <ClosetHanger          position={[  16.5,    7,  -1.2]} rotation={[           0,               0,           0]} />
            <ClosetHanger          position={[  16.5,    7,  -1.0]} rotation={[           0,               0,           0]} />
            <ClosetHanger          position={[  16.5,    7,  -0.6]} rotation={[           0,               0,           0]} />
            <ClosetHanger          position={[  16.5,    7,  -0.4]} rotation={[           0,               0,           0]} />
            <ClosetHanger          position={[  16.5,    7,  -0.2]} rotation={[           0,               0,           0]} />

            <GuitarStand           position={[     2, -6.5,   -5]} rotation={[            0,    -Math.PI / 4,           0]} />
            <Guitar                position={[   2.5,  0.5, -5.7]} rotation={[            0,    -Math.PI / (3 / 2.2), Math.PI / 12]} />

            <CardCase              position={[    14,    1,    7]} rotation={[            0,    -Math.PI / 6,           0]} />
            <Wallet                position={[    18,    1,    7]} rotation={[            0,     Math.PI / 3,           0]} />

            {/* <Ragdoll position={[0, 0, 0]} /> */}
          {/* </Debug> */}
        </Physics>
      </Canvas>
      
      <InfoButton />
    </>
  );
};
